import { FormDownloadLink } from 'platform/shared/health-apps';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { submitTransformer } from '../config/submitTransformer';
import { APP_URLS } from '../utils/appUrls';
import { API_ENDPOINTS } from '../utils/constants';
import { selectPdfFullName } from '../selectors';

// app formId is '1010ez' for vets-api and can't be changed
const VA_FORM_ID = '10-10EZ';

const PdfDownloadLink = ({ formConfig }) => {
  const fullName = useSelector(selectPdfFullName);
  const downloadConfig = useMemo(
    () => ({ ...formConfig, formId: VA_FORM_ID }),
    [formConfig],
  );
  return (
    <FormDownloadLink
      apiEndpoint={API_ENDPOINTS.downloadPdf}
      formConfig={downloadConfig}
      fullName={fullName}
      rootUrl={APP_URLS.hca}
      transformer={submitTransformer}
    />
  );
};

PdfDownloadLink.propTypes = {
  formConfig: PropTypes.object,
};

export default PdfDownloadLink;
